import MyNumberInput from "common/components/atoms/MyNumberInput";
import { Form } from "react-bootstrap";
import styled from "styled-components";

type Props = {
  yearMonth: Date;
  changed: (newDate: Date) => void;
};

export const SelectYearMonthControl = ({ yearMonth, changed }: Props) => {
  return (
    <SSelectRootDiv>
      <MyNumberInput
        initialValue={yearMonth.getFullYear()}
        min={2000}
        max={new Date().getFullYear()}
        changed={(newValue) => {
          changed(new Date(newValue, yearMonth.getMonth() - 1));
        }}
        style={{ lineHeight: "1.5", width: "100px" }}
      />
      <Form.Label>年</Form.Label>
      <MyNumberInput
        initialValue={yearMonth.getMonth() + 1}
        min={0}
        max={13}
        changed={(newvalue) => {
          if (newvalue === 0) {
            changed(new Date(yearMonth.getFullYear() - 1, 11));
          } else if (newvalue === 13) {
            changed(new Date(yearMonth.getFullYear() + 1, 0));
          } else {
            changed(new Date(yearMonth.getFullYear(), newvalue - 1));
          }
        }}
        style={{ lineHeight: "1.5", width: "100px" }}
      />
      {/* <Form.Select
        value={month}
        onChange={(e) => {
          monthChanged(Number(e.currentTarget.value));
        }}
        style={{ width: "100px" }}
      >
        {[...Array(12)].map((_, idx) => (
          <option key={`month_${idx}`} value={idx + 1}>
            {idx + 1}
          </option>
        ))}
      </Form.Select> */}
      <Form.Label>月</Form.Label>
    </SSelectRootDiv>
  );
};

const SSelectRootDiv = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  direction: col;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: baseline;
`;
